module.exports = __webpack_public_path__ + "static/consaltansy_service-f81811c35d62a01cba9ef03e1f7f6337.svg";